import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';

export const Wrapper = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${RFValue(12)}px 24px ${RFValue(4)}px;
`;

export const Title = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(16)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;
